import React from 'react';

type Props = {
  onToggle: () => void;
  className?: string;
  bgColor?: `bg-${string}`;
  isToggle: boolean;
  isLoading?: boolean;
};

function ToggleButton({
  onToggle,
  className = '',
  bgColor = 'bg-primary',
  isToggle = false,
  isLoading = false,
}: Props) {
  return (
    <button
      className={`${className} relative rounded-full w-16 h-8 flex items-center ${
        isLoading ? 'opacity-70 cursor-not-allowed' : ''
      }`}
      onClick={onToggle}
      disabled={isLoading}
    >
      <div
        className={`w-full h-full transition ${
          isToggle ? bgColor : 'bg-neutral-100'
        } rounded-full shadow-md outline-none`}
      ></div>
      <div
        className={`absolute inline-flex items-center justify-center w-[37.5%] aspect-square transition-all duration-200 ease-in-out transform bg-white rounded-full shadow-sm ${
          isToggle
            ? 'translate-x-full left-[18.75%]'
            : 'translate-x-0 left-[6.25%]'
        }`}
      >
        {isLoading && (
          <div className="w-3 h-3 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
        )}
      </div>
    </button>
  );
}

export default ToggleButton;
